import { useParams, Link } from 'react-router-dom';
import { useState, useEffect } from 'react';
import './CommercialDetail.css';
import { FaMapMarkerAlt, FaBed, FaBath, FaRuler, FaPhone, FaEnvelope, FaArrowLeft, FaTimes, FaChevronLeft, FaChevronRight, FaLayerGroup, FaBuilding } from 'react-icons/fa';

export default function CommercialDetail() {
  const { slug } = useParams();
  const [mainImage, setMainImage] = useState(0);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(0);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);

  // Commercial property data with different images for each property
  const propertyData = {
    'connaught-place-office-space': {
      title: 'Premium Office Space',
      location: 'Connaught Place, Delhi',
      type: 'Office',
      builder: 'DLF Commercial',
      floors: '5th Floor',
      category: 'Commercial',
      area: '5000 sq.ft',
      description: 'Premium office space in the heart of Connaught Place, Delhi\'s premier business district. Features modern infrastructure, high-speed elevators, and 24/7 power backup. Perfect for corporate offices and businesses.',
      features: [
        'Central Air Conditioning',
        'High-Speed Elevators',
        '24/7 Power Backup',
        'Reserved Parking',
        'Security 24/7',
        'Conference Rooms',
        'Cafeteria Access',
        'Modern Infrastructure'
      ],
      images: [
        '/assets/commercial/connaught-place-office-space/main.jpg',
        '/assets/commercial/connaught-place-office-space/image1.jpg',
        '/assets/commercial/connaught-place-office-space/image2.jpg',
        '/assets/commercial/connaught-place-office-space/image3.jpg'
      ]
    },
    'nehru-place-retail-shop': {
      title: 'Retail Shop Space',
      location: 'Nehru Place, Delhi',
      type: 'Retail',
      builder: 'Prestige Commercial',
      floors: 'Ground Floor',
      category: 'Commercial',
      area: '2500 sq.ft',
      description: 'Prime retail shop space in Nehru Place, ideal for electronics, mobile, or computer showroom. High footfall area with excellent visibility and accessibility.',
      features: [
        'Ground Floor Access',
        'High Footfall Area',
        'Excellent Visibility',
        'Parking Available',
        'Security System',
        'Power Backup',
        'Wide Frontage'
      ],
      images: [
        '/assets/commercial/nehru-place-retail-shop/main.jpg',
        '/assets/commercial/nehru-place-retail-shop/image1.jpg',
        '/assets/commercial/nehru-place-retail-shop/image2.jpg'
      ]
    },
    'saket-shopping-complex': {
      title: 'Shopping Complex',
      location: 'Saket, New Delhi',
      type: 'Complex',
      builder: 'Oberoi Realty',
      floors: 'Multiple Floors',
      category: 'Commercial',
      area: '15000 sq.ft',
      description: 'Large shopping complex in Saket with multiple retail spaces. Ideal for brands and businesses looking for premium retail space in South Delhi\'s prime shopping destination.',
      features: [
        'Multiple Retail Units',
        'Food Court',
        'Ample Parking',
        'Central HVAC',
        'Escalators & Elevators',
        'High Footfall',
        'Brand Presence',
        'Entertainment Zone'
      ],
      images: [
        '/assets/commercial/saket-shopping-complex/main.jpg',
        '/assets/commercial/saket-shopping-complex/image1.jpg',
        '/assets/commercial/saket-shopping-complex/image2.jpg',
        '/assets/commercial/saket-shopping-complex/image3.jpg'
      ]
    },
    'cyber-city-corporate-office': {
      title: 'Corporate Office',
      location: 'Cyber City, Gurgaon',
      type: 'Office',
      builder: 'Tata Realty',
      floors: '12th Floor',
      category: 'Commercial',
      area: '8000 sq.ft',
      description: 'Grade A corporate office space in Cyber City, Gurgaon\'s premier business hub. State-of-the-art amenities with excellent connectivity to Delhi and IGI Airport.',
      features: [
        'Grade A Building',
        'Premium Lobby',
        'High-Speed Elevators',
        'Conference Facilities',
        'Cafeteria',
        'Gym Access',
        'Reserved Parking',
        'Metro Connectivity'
      ],
      images: [
        '/assets/commercial/cyber-city-corporate-office/main.jpg',
        '/assets/commercial/cyber-city-corporate-office/image1.jpg',
        '/assets/commercial/cyber-city-corporate-office/image2.jpg',
        '/assets/commercial/cyber-city-corporate-office/image3.jpg'
      ]
    },
    'rajouri-garden-showroom': {
      title: 'Premium Showroom',
      location: 'Rajouri Garden, Delhi',
      type: 'Showroom',
      builder: 'Lodha Developers',
      floors: 'Ground + 1st Floor',
      category: 'Commercial',
      area: '4000 sq.ft',
      description: 'Premium showroom space in the bustling market of Rajouri Garden. Perfect for automobile, furniture, or lifestyle brands with high visibility and footfall.',
      features: [
        'Double Height Ceiling',
        'Glass Facade',
        'Parking Space',
        'Wide Frontage',
        'Display Windows',
        'Storage Area',
        'Power Backup'
      ],
      images: [
        '/assets/commercial/rajouri-garden-showroom/main.jpg',
        '/assets/commercial/rajouri-garden-showroom/image1.jpg',
        '/assets/commercial/rajouri-garden-showroom/image2.jpg'
      ]
    },
    'vasant-kunj-restaurant-space': {
      title: 'Restaurant Space',
      location: 'Vasant Kunj, Delhi',
      type: 'Restaurant',
      builder: 'Godrej Properties',
      floors: 'Ground Floor',
      category: 'Commercial',
      area: '3500 sq.ft',
      description: 'Prime restaurant space in Vasant Kunj with outdoor seating possibility. Ideal for fine dining, cafe, or quick service restaurant with excellent visibility.',
      features: [
        'Commercial Kitchen Setup',
        'Outdoor Seating Area',
        'Parking Facility',
        'High Footfall',
        'Ventilation System',
        'Multiple Entry Points',
        'Power Backup'
      ],
      images: [
        '/assets/commercial/vasant-kunj-restaurant-space/main.jpg',
        '/assets/commercial/vasant-kunj-restaurant-space/image1.jpg',
        '/assets/commercial/vasant-kunj-restaurant-space/image2.jpg'
      ]
    }
  };

  const property = propertyData[slug] || propertyData['connaught-place-office-space'];

  const openLightbox = (index) => {
    setLightboxImage(index);
    setLightboxOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
    document.body.style.overflow = 'auto';
  };

  const nextImage = () => {
    setLightboxImage((prev) => (prev + 1) % property.images.length);
  };

  const prevImage = () => {
    setLightboxImage((prev) => (prev - 1 + property.images.length) % property.images.length);
  };

  const handleThumbnailClick = (index) => {
    setMainImage(index);
    openLightbox(index);
  };

  const handleMainImageClick = () => {
    openLightbox(mainImage);
  };

  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!lightboxOpen) return;
      
      if (e.key === 'Escape') closeLightbox();
      if (e.key === 'ArrowRight') nextImage();
      if (e.key === 'ArrowLeft') prevImage();
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [lightboxOpen, lightboxImage]);

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;

    if (isLeftSwipe) {
      nextImage();
    }
    if (isRightSwipe) {
      prevImage();
    }

    setTouchStart(0);
    setTouchEnd(0);
  };

  useEffect(() => {
    setMainImage(0);
  }, [slug]);

  return (
    <>
      <section className="property-detail-section">
        <div className="property-detail-container">
          
          <Link to="/properties/commercial" className="back-btn">
            <FaArrowLeft /> Back to Commercial Properties
          </Link>

          <div className="image-gallery">
            <div className="main-image" onClick={handleMainImageClick} style={{ cursor: 'pointer' }}>
              <img src={property.images[mainImage]} alt={property.title} />
              <div className="zoom-hint">Click to zoom</div>
            </div>
            <div className="thumbnail-row">
              {property.images.map((img, index) => (
                <div 
                  key={index}
                  className={`thumbnail ${mainImage === index ? 'active' : ''}`}
                  onClick={() => handleThumbnailClick(index)}
                >
                  <img src={img} alt={`View ${index + 1}`} />
                  <div className="thumbnail-overlay">Click to zoom</div>
                </div>
              ))}
            </div>
          </div>

          <div className="property-info-grid">
            
            <div className="main-info">
              <div className="property-header">
                <h1>{property.title}</h1>
                <div className="property-location">
                  <FaMapMarkerAlt /> {property.location}
                </div>
              </div>

              <div className="quick-stats">
                <div className="stat-item">
                  <FaBuilding className="stat-icon" />
                  <div>
                    <span className="stat-value">{property.type}</span>
                    <span className="stat-label">Type</span>
                  </div>
                </div>
                <div className="stat-item">
                  <FaRuler className="stat-icon" />
                  <div>
                    <span className="stat-value">{property.area}</span>
                    <span className="stat-label">Area</span>
                  </div>
                </div>
                <div className="stat-item">
                  <FaLayerGroup className="stat-icon" />
                  <div>
                    <span className="stat-value">{property.floors}</span>
                    <span className="stat-label">Floor</span>
                  </div>
                </div>
              </div>

              <div className="description-section">
                <h2>About Property</h2>
                <p>{property.description}</p>
              </div>

              <div className="details-section">
                <h2>Property Details</h2>
                <div className="details-grid">
                  <div className="detail-row">
                    <span className="detail-label">Property Type:</span>
                    <span className="detail-value">{property.type}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Builder:</span>
                    <span className="detail-value">{property.builder}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Category:</span>
                    <span className="detail-value">{property.category}</span>
                  </div>
                  <div className="detail-row">
                    <span className="detail-label">Floor:</span>
                    <span className="detail-value">{property.floors}</span>
                  </div>
                </div>
              </div>

              <div className="features-section">
                <h2>Key Features & Amenities</h2>
                <ul className="features-list">
                  {property.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="contact-sidebar">
              <div className="price-card">
                <h3>Price on Request</h3>
                <p>Contact us for pricing details</p>
              </div>

              <div className="contact-card">
                <h3>Contact Agent</h3>
                <div className="contact-info">
                  <div className="contact-item">
                    <FaPhone />
                    <a href="tel:+919818312077">+91 9818312077</a>
                  </div>
                  <div className="contact-item">
                    <FaEnvelope />
                    <a href="mailto:info@lutyens.com">info@lutyens.com</a>
                  </div>
                </div>
                <Link to="/contact" className="schedule-btn">
                  Schedule a Visit
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {lightboxOpen && (
        <div 
          className="lightbox-overlay" 
          onClick={closeLightbox}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <button 
            className="lightbox-close" 
            onClick={closeLightbox}
            aria-label="Close"
          >
            <FaTimes />
          </button>

          <button 
            className="lightbox-prev" 
            onClick={(e) => { e.stopPropagation(); prevImage(); }}
            aria-label="Previous Image"
          >
            <FaChevronLeft />
          </button>

          <div 
            className="lightbox-content" 
            onClick={(e) => e.stopPropagation()}
          >
            <img 
              src={property.images[lightboxImage]} 
              alt={`Property view ${lightboxImage + 1}`}
              className="lightbox-image"
            />
          </div>

          <button 
            className="lightbox-next" 
            onClick={(e) => { e.stopPropagation(); nextImage(); }}
            aria-label="Next Image"
          >
            <FaChevronRight />
          </button>

          <div className="lightbox-counter">
            {lightboxImage + 1} / {property.images.length}
          </div>

          <div className="lightbox-thumbnails">
            {property.images.map((img, index) => (
              <div
                key={index}
                className={`lightbox-thumb ${lightboxImage === index ? 'active' : ''}`}
                onClick={(e) => { e.stopPropagation(); setLightboxImage(index); }}
              >
                <img src={img} alt={`Thumbnail ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
